import React, { FC } from "react";
import styles from "./EventDetails.module.scss";

import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import DescriptionIcon from "@mui/icons-material/Description";
import Skeleton from "@mui/material/Skeleton";

export interface EventDetailsProps {
  selectedEventDetails: EventResources;
}

export interface EventResources {
  others: ResourceItem[];
  scores: ResourceItem[];
  song_list: Song[];
}

interface ResourceItem {
  display_name: string;
  uri: string;
}

interface Song {
  arrangement: string;
  composer: string;
  display_name: string;
  song_id: number;
  resources: SongResource;
}

interface SongResource {
  others: ResourceItem[];
  scores: ResourceItem[];
  videos: ResourceItem[];
}

const EventDetails: FC<EventDetailsProps> = (props: EventDetailsProps) => {
  const downloadResource = (uri: string) => {
    window.open(uri, "_blank");
  };

  return (
    <div
      className={styles.EventDetails + " row col-lg-10 mx-auto"}
      data-testid="EventDetails"
    >
      {props.selectedEventDetails.others?.length > 0 && (
        <h4 className={styles.EventDetails__heading}>Useful Links</h4>
      )}
      {props.selectedEventDetails.others?.map((resource: ResourceItem) => {
        return (
          <div className="text-center">
            <span>
              <DescriptionIcon className="mx-2" />
            </span>
            <a href={resource.uri} target="_blank">
              {resource.display_name}
            </a>
          </div>
        );
      })}

      {props.selectedEventDetails.scores?.length > 0 && (
        <h4 className={styles.EventDetails__heading + " mt-5"}>Scores/PDFs</h4>
      )}
      <div className="row mx-auto">
        {props.selectedEventDetails.scores?.map((score: ResourceItem) => {
          return (
            <div
              className={
                styles.EventDetails__pdf +
                " text-center col-lg-4 col-md-6 col-12"
              }
              onClick={() => downloadResource(score.uri)}
            >
              <img
                className={styles.EventDetails__pdf_img}
                src={require("../../assets/Images/pdf.png")}
              />
              <div className={styles.EventDetails__pdf_name}>
                <a
                  href="javascript:void(0);"
                  onClick={() => downloadResource(score.uri)}
                >
                  {score.display_name}
                </a>
              </div>
            </div>
          );
        })}
      </div>

      {props.selectedEventDetails.song_list?.length > 0 && (
        <h4 className={styles.EventDetails__heading + " mt-5"}>Songs</h4>
      )}
      {props.selectedEventDetails.song_list?.map((song: Song) => {
        return (
          <Accordion>
            <AccordionSummary
              className={styles.EventDetails__item}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2-content"
              id="panel2-header"
            >
              <MusicNoteIcon />
              <Typography component="span">{song.display_name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className={styles.EventDetails__item_content}>
                {/* Useful Links */}
                <div>
                  {song.resources.others.length > 0 && (
                    <h4 className={styles.EventDetails__item_content_heading}>
                      Useful Links
                    </h4>
                  )}
                  {song.resources.others?.map((resource: ResourceItem) => {
                    return (
                      <a href={resource.uri} target="_blank">
                        {resource.display_name}
                      </a>
                    );
                  })}
                </div>

                {/* PDF/Scores */}
                {song.resources.scores.length > 0 && (
                  <>
                    <h4
                      className={
                        styles.EventDetails__item_content_heading + " mb-4"
                      }
                    >
                      Scores/PDFs
                    </h4>
                    <div className="row">
                      <img
                        className={
                          styles.EventDetails__item_content_pdf +
                          " col-lg-3 col-md-4 col-6"
                        }
                        src={require("../../assets/Images/pdf.png")}
                        onClick={() =>
                          downloadResource(song.resources.scores[0].uri)
                        }
                      />
                      <a
                        href="javascript:void(0);"
                        onClick={() =>
                          downloadResource(song.resources.scores[0].uri)
                        }
                      >
                        {song.resources.scores[0].display_name}
                      </a>
                    </div>
                  </>
                )}

                {/* Video Links */}
                <div>
                  {song.resources.videos.length > 0 && (
                    <h4 className={styles.EventDetails__item_content_heading}>
                      Videos
                    </h4>
                  )}
                  {song.resources.videos?.map((video) => {
                    return (
                      <iframe
                        className={styles.EventDetails__item_content_video}
                        src={video.uri}
                      ></iframe>
                    );
                  })}
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
};

export default EventDetails;
